import { render, staticRenderFns } from "./WorkingGroupSubsections.vue?vue&type=template&id=503962b8&"
import script from "./WorkingGroupSubsections.vue?vue&type=script&lang=js&"
export * from "./WorkingGroupSubsections.vue?vue&type=script&lang=js&"
import style0 from "./WorkingGroupSubsections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports